import { store } from "app.store";
import {
  PRODUCT_CATEGORY_API,
  PRODUCT_CATEGORY_API_SORT,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { UpdatedSortEntityModel } from "shared/models/updated-sort-entity-model";
import { apiClient } from "shared/plugins/http-service";
import {
  CreateProductCategoryModel,
  ProductCategoryModel,
  UpdatedProductCategoryModel,
} from "./product-category.models";

export const removeProductCategory = async (
  removedModel: RemovedEntityModel<number>
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_CATEGORY_API}/remove_list`,
    removedModel
  );
  return response;
};

export const updateSortProductCategory = async (
  updatedSortModel: UpdatedSortEntityModel<number>[]
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_CATEGORY_API_SORT}`,
    updatedSortModel
  );
  return response;
};

export const getProductCategoryByIdApi = async (
  id: number,
  langCode?: string
) => {
  return await apiClient.getHttp<ProductCategoryModel>(
    `${PRODUCT_CATEGORY_API}/${id}`,
    { params: { langCode } }
  );
};

export const getProductCategoryListApi = async (langCode?: string) => {
  return await apiClient.getHttp<ProductCategoryModel[]>(
    `${PRODUCT_CATEGORY_API}`,
    { params: { langCode } }
  );
};

export const addProductCategoryApi = async (
  model: CreateProductCategoryModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<number>(
    `${PRODUCT_CATEGORY_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const updateProductCategoryApi = async (
  model: UpdatedProductCategoryModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp<number>(
    `${PRODUCT_CATEGORY_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};
